const initialState = {
    inputFullname: '',
    inputMobile: '',
    
};
const vipServices = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_VIP_SERVICES':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default vipServices;
